import React from 'react';
interface StructuredDataProps {
  data: Record<string, unknown> | Record<string, unknown>[];
}
export function StructuredData({
  data
}: StructuredDataProps) {
  return <script type="application/ld+json" dangerouslySetInnerHTML={{
    __html: JSON.stringify(data)
  }} data-id="element-236" />;
}
// Organisation + LocalBusiness schema (use on every page via App)
export function OrganizationSchema() {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': 'https://smithandjengs.com/#business',
    name: 'Smith & Jengs Cleaning Services',
    description: 'Professional residential and commercial cleaning services in Bicester and Oxfordshire, UK. Eco-friendly products, vetted cleaners, 100% satisfaction guarantee.',
    url: 'https://smithandjengs.com',
    logo: 'https://cdn.magicpatterns.com/uploads/5m425UHDJynsrvkfvBo6sp/sj-website-logo-colour.svg',
    image: 'https://cdn.magicpatterns.com/uploads/fssYpKf8swLzdNNaRcNwxG/sj-website-home-banner-1.png',
    telephone: ['+447432285564', '+441869601439'],
    email: 'smithsandjengs@yahoo.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Bicester',
      addressRegion: 'Oxfordshire',
      addressCountry: 'GB'
    },
    areaServed: {
      '@type': 'GeoCircle',
      geoMidpoint: {
        '@type': 'GeoCoordinates',
        latitude: 51.9,
        longitude: -1.15
      },
      geoRadius: '30000'
    },
    priceRange: '££',
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      opens: '08:00',
      closes: '18:00'
    },
    sameAs: ['https://www.facebook.com/smithsandjengs'],
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Cleaning Services',
      itemListElement: [{
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Commercial Cleaning',
          description: 'Professional commercial cleaning services for offices and business premises.'
        }
      }, {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Basic Home Cleaning',
          description: 'Regular residential cleaning to keep your home spotless.'
        }
      }, {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Spring / Deep Cleaning',
          description: 'Thorough deep cleaning for a fresh start in your home or office.'
        }
      }, {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Move-In / Move-Out Cleaning',
          description: 'Complete cleaning service for property transitions.'
        }
      }, {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Post Renovation Cleaning',
          description: 'Specialist cleaning after building or renovation work.'
        }
      }, {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Airbnb / Short Term Rental Cleaning',
          description: 'Turnover cleaning for short-term rental properties.'
        }
      }]
    }
  };
  return <StructuredData data={data} data-id="element-237" />;
}
// Website schema
export function WebsiteSchema() {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': 'https://smithandjengs.com/#website',
    name: 'Smith & Jengs Cleaning Services',
    url: 'https://smithandjengs.com',
    publisher: {
      '@id': 'https://smithandjengs.com/#business'
    }
  };
  return <StructuredData data={data} data-id="element-238" />;
}
// Breadcrumb schema
interface BreadcrumbItem {
  name: string;
  url: string;
}
export function BreadcrumbSchema({
  items
}: {
  items: BreadcrumbItem[];
}) {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url
    }))
  };
  return <StructuredData data={data} data-id="element-239" />;
}
// FAQ schema
interface FAQItem {
  question: string;
  answer: string;
}
export function FAQSchema({
  faqs
}: {
  faqs: FAQItem[];
}) {
  const filteredFaqs = faqs.filter(faq => faq.answer && faq.answer.length > 0);
  const data = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: filteredFaqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer
      }
    }))
  };
  return <StructuredData data={data} data-id="element-240" />;
}